import { render, staticRenderFns } from "./CompLive.vue?vue&type=template&id=a858b772&"
import script from "./CompLive.vue?vue&type=script&lang=js&"
export * from "./CompLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports